var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRating(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1693_1219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.53125 21.9277H9.10406C9.69797 21.9277 10.267 22.1634 10.687 22.5834C10.8966 22.7934 11.1441 22.957 11.4131 23.0686C11.6847 23.1808 11.9757 23.2387 12.2695 23.2388H16.9425C18.0145 23.2388 18.9314 22.4681 19.1161 21.412L19.8525 17.1937C20.0358 16.1466 19.2295 15.1875 18.1664 15.1875H14.5837L15.338 12.8395C15.4041 12.638 15.4355 12.4331 15.4355 12.2316C15.4355 11.4089 14.9114 10.643 14.0869 10.3739C13.6369 10.2267 13.1531 10.4719 13.0059 10.9219L11.9381 14.2289C11.8406 14.5273 11.6762 14.7995 11.4574 15.0246C11.2386 15.2497 10.9713 15.4219 10.6758 15.5278L8.53125 16.2961M12 0.703125L13.1024 2.50256L15.1544 2.99494L13.7836 4.59938L13.9495 6.70312L12 5.89528L10.0505 6.70312L10.2164 4.59938L8.84559 2.99494L10.8976 2.50256L12 0.703125ZM20.1425 3.46875L19.0401 5.26819L16.9881 5.76056L18.3588 7.365L18.193 9.46875L20.1425 8.66091L22.092 9.46875L21.9262 7.365L23.2969 5.76056L21.2448 5.26819L20.1425 3.46875ZM3.85753 3.46875L4.95989 5.26819L7.01189 5.76056L5.64117 7.365L5.80702 9.46875L3.85753 8.66091L1.908 9.46875L2.07384 7.365L0.703125 5.76056L2.75517 5.26819L3.85753 3.46875ZM4.96875 14.8594H8.53125V23.2969H4.96875V14.8594Z",
    stroke: "#496683",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1693_1219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/Rating.a2d7cba217c32b96fbb0bd3053e36467.svg";
export { ForwardRef as ReactComponent };